import React, { useState, useMemo, useRef } from "react";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import menu from "../../assets/icons/dots in image viwer.svg";
import DropDownBox from "../custom/DropDownBox/DropDownBox";
import useOutsideClick from "../../hooks/useOutsideClick";
import generateRandomIDWithDate, {
  generateMenu,
} from "../../utils/MenuGenerator";

import {
  getImageDimensions,
  ImageSizeAndDimensionChecker,
  ImgIcon,
} from "../../utils/utils";
import deleteIcon from "../../assets/icons/DELETE __ DARK Red.svg";
import AddForIcon from "../../assets/icons/AddForIcon";
import ImageIcon from "./ImageIcon";
import LeftArrow from "../../assets/icons/LeftArrow";
import RightArrowIcon from "../../assets/icons/RightArrowIcon";

function cn(...inputs: any) {
  return twMerge(clsx(inputs));
}

const EditButton = ({
  imageId,
  setImages,
  setCurrentIndex,
  dimension,
}: any) => {
  const handleAddImage = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const { width, height } = await getImageDimensions(file);
      if (
        !ImageSizeAndDimensionChecker(
          width,
          height,
          dimension[0],
          dimension[0],
          file.size
        )
      ) {
        e.target.value = "";
        return;
      }
      const randomId = generateRandomIDWithDate();
      const reader = new FileReader();

      reader.onloadend = () => {
        const newImage = { id: randomId, image: reader.result as string };
        setImages((prevImages: any) => {
          const updatedImages = [...prevImages, newImage];
          // Set the currentIndex to the new image's index
          setCurrentIndex(updatedImages.length - 1);
          return updatedImages;
        });
      };

      reader.readAsDataURL(file);
    }
  };

  const handelDeleteImage = async () => {
    setImages((prevImages: any) => {
      const updatedImages = prevImages.filter((img: any) => img.id !== imageId);
      setCurrentIndex(updatedImages.length - 1);
      return updatedImages;
    });
  };

  const CarouselBox = [
    {
      name: "Add Image",
      tag: "AddImage",
      icon: AddForIcon,
      action: "test",
      color: "#1e1850",
    },
    {
      name: "Delete Image",
      tag: "deleteImage",
      icon: () => ImgIcon(deleteIcon, 28, 28),
      action: "deleteImage",
      color: "#eb0707",
    },
  ];
  const [openDropDown, setOpenDropDown] = useState<boolean>(false);
  const dropDownRef = useRef<HTMLButtonElement>(null);

  const closeDropDown = () => {
    setOpenDropDown(false);
  };

  useOutsideClick(dropDownRef, closeDropDown);

  const clubDropDown = generateMenu(
    CarouselBox,
    {
      test: {
        cb: () => {},
        isAsync: false,
        params: {},
      },
      deleteImage: {
        cb: handelDeleteImage,
        isAsync: false,
        params: {},
      },
    },
    {
      AddImage: {
        component: (item, onClick, closeDropDown) => {
          return (
            <>
              <input
                hidden
                accept={"image/*"}
                onChange={(e) => {
                  handleAddImage(e);
                }}
                type="file"
                id="uploadCarouselImage"
              />
              <label
                htmlFor="uploadCarouselImage"
                className="hover:bg-gray-100 w-full flex items-center justify-start gap-1 rounded-md  py-2 px-2 "
              >
                {/* <img loading="lazy" src={addIcon} alt="" /> */}
                <AddForIcon />
                <p className="text-primary dark:text-white">Add Img</p>
              </label>
            </>
          );
        },
      },
    }
  );
  return (
    <>
      <button
        className="flex gap-2 items-center  p-2 rounded-md "
        onClick={() => setOpenDropDown((prev) => !prev)}
        type="button"
      >
        <img loading="lazy" src={menu} alt="" />
      </button>
      {/* @ts-ignore */}
      <div ref={dropDownRef}>
        {openDropDown && (
          <DropDownBox
            dropDownConfig={clubDropDown}
            title=""
            closeDropDown={closeDropDown}
            className=" absolute top-10 right-[20px]  w-[150px]  "
          />
        )}
      </div>
    </>
  );
};

const LocalCarousel = ({
  images = [],
  setImages,
  dimension,
}: {
  images?: { id: number; image: string }[];
  setImages: any;
  clickHereRef?: string;
  dimension: any;
}) => {
  const [currentIndex, setCurrentIndex] = useState(
    images[images.length - 1].id
  );
  const visibleDotsCount = 5; // Number of dots to display at a time

  const hasImages = useMemo(() => Boolean(images.length), [images]);

  const handleDotClick = (index: any) => {
    setCurrentIndex(index);
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  // Determine the visible range of dots
  const startDot = Math.max(
    0,
    Math.min(
      currentIndex - Math.floor(visibleDotsCount / 2),
      images.length - visibleDotsCount
    )
  );
  const visibleDots = images.slice(startDot, startDot + visibleDotsCount);

  return (
    <div className="relative w-full h-[200px] flex flex-col hover:bg-white/10 duration-300 ease-in-out group overflow-hidden">
      {/* Dots Positioned Below the Image */}
      {hasImages && (
        <div className="gap-1.5 w-full p-0 px-4 pt-4 flex justify-center absolute bottom-5 z-10">
          {visibleDots.map((item, index) => {
            const actualIndex = startDot + index; // Map visible dot index to actual image index
            const isActive = currentIndex === actualIndex;

            return (
              <div
                key={item.id}
                onClick={() => handleDotClick(actualIndex)}
                className={cn(
                  "overflow-hidden relative shrink-0 h-2 bg-white bg-opacity-30 rounded-full cursor-pointer",
                  isActive ? "w-[30px]" : "w-2"
                )}
              >
                {isActive && (
                  <div className="absolute bottom-0 left-0 w-full h-2 bg-transparent rounded-full">
                    <div className="h-full bg-white rounded-full" />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* Image Display */}

      <div className="relative w-full h-full">
        {hasImages &&
          images.map((item, index) => (
            <div
              key={item.id}
              className={cn(
                `flex flex-col w-full h-full absolute transition-opacity duration-1000 cursor-pointer`,
                index === currentIndex ? "opacity-100" : "opacity-0"
              )}
            >
              <div className=" absolute z-40 right-2 top-2">
                <EditButton
                  imageId={item.id}
                  setImages={setImages}
                  setCurrentIndex={setCurrentIndex}
                  dimension={dimension}
                />
              </div>

              <div className="w-full h-[300px] group-hover:scale-110 transition-all duration-300 ease-in-out">
                <div
                  style={{
                    backgroundImage: `url('${item.image}')`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    width: "100%",
                    height: "100%",
                  }}
                />
              </div>
            </div>
          ))}
      </div>

      {/* Arrows */}
      {hasImages && (
        <>
          {/* <img loading="lazy"
            className="absolute top-1/2 left-1 transform -translate-y-1/2 bg-white bg-opacity-50 hover:bg-opacity-80 rounded-full w-8 h-8 flex items-center justify-center focus:outline-none cursor-pointer"
            onClick={handlePrev}
            src={leftArrowIcon}
            alt="left-icon"
          /> */}

          <ImageIcon
            className="absolute top-1/2 left-1 transform -translate-y-1/2 bg-white bg-opacity-50 hover:bg-opacity-80 rounded-full w-8 h-8 flex items-center justify-center focus:outline-none cursor-pointer"
            onClick={handlePrev}
            Icon={LeftArrow}
            width={24}
            height={24}
          />

          <ImageIcon
            className="absolute top-1/2 right-1 transform -translate-y-1/2 bg-white bg-opacity-50 hover:bg-opacity-80 rounded-full w-8 h-8 flex items-center justify-center focus:outline-none cursor-pointer"
            onClick={handleNext}
            Icon={RightArrowIcon}
            width={24}
            height={24}
          />

          {/* <img loading="lazy"
            className="absolute top-1/2 right-1 transform -translate-y-1/2 bg-white bg-opacity-50 hover:bg-opacity-80 rounded-full w-8 h-8 flex items-center justify-center focus:outline-none cursor-pointer"
            onClick={handleNext}
            src={rightArrowIcon}
            alt="right-icon"
          /> */}
        </>
      )}
    </div>
  );
};

export default LocalCarousel;
